import { render, staticRenderFns } from "./platformData.vue?vue&type=template&id=1b735d6d"
import script from "./platformData.vue?vue&type=script&lang=js"
export * from "./platformData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports